<template>
  <div class="footerPage">
    <!-- 返回顶部 -->
    <div class="backTop flex-rowc" @click="backTop">Back to Top</div>
    <!-- 底部 -->
    <div class="footer">
      <div class="footerContent" v-if="false">
        <div class="footerLeft">
          <div class="footerLogo">
            <img src="assets/img/logo.png" alt="" />
          </div>
          <div class="footerText">
            <p>版权所有 © 2023 北京中软国际信息技术有限公司</p>
            <p>京ICP备18000000号-1</p>
            <p>京公网安备11010802020235号</p>
          </div>
        </div>
        <div class="footerRight">
          <div class="footerRightTop">
            <div class="footerRightTopLeft">
              <p>联系我们</p>
              <p>400-000-0000</p>
            </div>
            <div class="footerRightTopRight">
              <p>关注我们</p>
              <div class="footerRightTopRightImg">
                <img src="assets/img/wechat.png" alt="" />
                <img src="assets/img/weibo.png" alt="" />
              </div>
            </div>
          </div>
          <div class="footerRightBottom">
            <p>京公网安备11010802020235号</p>
          </div>
        </div>
      </div>
    </div>
    <div class="copy"></div>
  </div>
</template>
<script>
export default {
  name: "myFooter",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  },
};
</script>
<style scoped lang="less">
.footerPage {
  .backTop {
    height: 60px;
    background: #434e5a;
    font-size: 18px;
    color: #FFFFFF;
    cursor: pointer;
  }
  .footer {
    height: 600px;
    background: url("../assets/images/footer_bg.jpg") no-repeat center;
    background-size: cover;
  }
  .copy {
    height: 200px;
    background: #383C3F;
  }
}
</style>